import React, { useEffect, useState } from 'react';
import { Button, Modal, Select } from 'antd';

const { Option } = Select;

interface DuplicationReasonPopupProps {
    isOpen: boolean;
    partName: string;
    onConfirm: (reason: string) => void;
    onCancel?: () => void;
    confirmLoading?: boolean;
}

const DuplicationReasonPopup: React.FC<DuplicationReasonPopupProps> = ({
    isOpen,
    partName,
    onConfirm,
    onCancel,
    confirmLoading = false,
}) => {
    const [selectedReason, setSelectedReason] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setSelectedReason('');
        }
    }, [isOpen]);

    const handleConfirm = () => {
        onConfirm(selectedReason);
    };

    return (
        <Modal
            title="Select a reason for the new file"
            open={isOpen}
            onOk={handleConfirm}
            onCancel={onCancel}
            confirmLoading={confirmLoading}
            footer={[
                <Button key="back" onClick={onCancel} disabled={confirmLoading}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={handleConfirm}
                    disabled={!selectedReason}
                    loading={confirmLoading}
                >
                    Confirm
                </Button>,
            ]}
        >
            <p>It appears that you are updating a file for {partName}. Please select a reason for the change.</p>
            <Select value={selectedReason} onChange={setSelectedReason} style={{ width: '100%' }}>
                <Option value="">Please select...</Option>
                <Option value="To Correct or Provide Additional Information">
                    To Correct or Provide Additional Information
                </Option>
                <Option value="To Update the Revision">To Update the Revision</Option>
            </Select>
        </Modal>
    );
};

export default DuplicationReasonPopup;
